import { render, staticRenderFns } from "./AllDeliveryReceipts.vue?vue&type=template&id=82ef0028&scoped=true&"
import script from "./AllDeliveryReceipts.vue?vue&type=script&lang=js&"
export * from "./AllDeliveryReceipts.vue?vue&type=script&lang=js&"
import style0 from "./AllDeliveryReceipts.vue?vue&type=style&index=0&id=82ef0028&prod&lang=scss&scoped=true&"
import style1 from "./AllDeliveryReceipts.vue?vue&type=style&index=1&id=82ef0028&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ef0028",
  null
  
)

export default component.exports